"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable dot-notation */
const react_1 = __importStar(require("react"));
const UI_1 = require("~/components/UI");
const Viewer_1 = __importDefault(require("~/components/Cad3d/Viewer"));
const react_i18next_1 = require("react-i18next");
const redux_1 = require("redux");
const react_redux_1 = require("react-redux");
const useWindowDimensions_1 = __importDefault(require("~/hooks/useWindowDimensions"));
const utils_1 = require("~/utils/utils");
const actions_1 = require("~/store/actions");
const selectors_1 = require("~/store/selectors");
const utils_3d_1 = require("~/components/Cad3d/utils/utils.3d");
const consts_1 = require("~/store/consts");
const types_1 = require("~/store/types");
const ItemPropertiesList_1 = __importDefault(require("./ItemPropertiesList"));
const ItemImagePropertiesList_1 = __importDefault(require("./ItemImagePropertiesList"));
const ItemSizeEditor_1 = __importDefault(require("./ItemSizeEditor"));
const ItemPropertiesWidget_scss_1 = __importDefault(require("./ItemPropertiesWidget.scss"));
function ItemPropertiesWidget() {
    var _a;
    const { t } = (0, react_i18next_1.useTranslation)('widgets');
    const { height: windowHeight } = (0, useWindowDimensions_1.default)();
    const { dispatchToggleWidget, dispatchRequestIncludedCompatibleFasteners } = (0, redux_1.bindActionCreators)({
        dispatchToggleWidget: actions_1.toggleWidget,
        dispatchRequestIncludedCompatibleFasteners: actions_1.requestIncludedCompatibleFasteners,
    }, (0, react_redux_1.useDispatch)());
    const [itemNumber, setItemNumber] = (0, react_1.useState)(null);
    const mountToListByItemNumber = (0, react_redux_1.useSelector)(selectors_1.selectIncludedCompatibleFasteners);
    const compatibleIncludedFastenerLoadingState = (0, react_redux_1.useSelector)(selectors_1.selectIncludedCompatibleFastenersLoadingState);
    const widgetHeight = (0, react_redux_1.useSelector)((0, selectors_1.selectWidgetHeight)(consts_1.WIDGETS.ITEM_PROPERTIES_WIDGET));
    const item = (0, react_redux_1.useSelector)((0, selectors_1.selectCatalogItemByItemNumber)(itemNumber));
    const selectedObjectsUUIDs = (0, react_redux_1.useSelector)(selectors_1.selectSelectedObjectsUUIDs);
    const [currentMountToList, setCurrentMountToList] = (0, react_1.useState)((item && mountToListByItemNumber.get(item.id)) || []);
    const [includedFasteners, setIncludedFasteners] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        if (compatibleIncludedFastenerLoadingState !== types_1.LOADING_STATE.LOADING && item) {
            const mountToList = mountToListByItemNumber.get(item.id);
            if (mountToList) {
                setCurrentMountToList(mountToList);
            }
            else {
                dispatchRequestIncludedCompatibleFasteners(item.id);
            }
        }
    }, [mountToListByItemNumber, compatibleIncludedFastenerLoadingState, item]);
    (0, react_1.useEffect)(() => {
        let timer;
        if (selectedObjectsUUIDs.length === 1) {
            const selectedObject = (0, utils_3d_1.getObjectByUUID)(Viewer_1.default.instance.getScene(), selectedObjectsUUIDs[0]);
            setItemNumber(selectedObject.partDetails.itemNumber);
        }
        if (selectedObjectsUUIDs.length !== 1) {
            timer = setTimeout(() => {
                dispatchToggleWidget({
                    widgetName: consts_1.WIDGETS.ITEM_PROPERTIES_WIDGET,
                    show: false,
                });
                setItemNumber(null);
            }, 0);
        }
        return () => clearTimeout(timer);
    }, [selectedObjectsUUIDs.length]);
    (0, react_1.useEffect)(() => {
        if (currentMountToList &&
            currentMountToList.length > 0 &&
            item &&
            (0, utils_1.isICatalogItem)(item) &&
            (item === null || item === void 0 ? void 0 : item.itemType.name) === 'Component') {
            const newIncludedFasteners = [];
            currentMountToList.forEach((mountTo) => {
                const fasteners = [];
                if (mountTo) {
                    mountTo === null || mountTo === void 0 ? void 0 : mountTo.compatibleFasteners.forEach((compatibleFastener) => {
                        var _a;
                        if (compatibleFastener.type === consts_1.INCLUDED) {
                            const { image, item_number, description } = (_a = compatibleFastener === null || compatibleFastener === void 0 ? void 0 : compatibleFastener.item) !== null && _a !== void 0 ? _a : {};
                            fasteners.push({
                                imageUrl: image.url,
                                name: item_number,
                                value: description,
                            });
                        }
                    });
                    if (fasteners.length) {
                        fasteners.sort((a, b) => Number(a.name) - Number(b.name));
                        newIncludedFasteners.push({
                            mountTo: mountTo.type,
                            fasteners,
                        });
                    }
                }
            });
            setIncludedFasteners(newIncludedFasteners);
        }
        else {
            setIncludedFasteners([]);
        }
    }, [currentMountToList]);
    if (!item || !(0, utils_1.isICatalogItem)(item)) {
        return null;
    }
    return (react_1.default.createElement(UI_1.Widget, { widgetName: consts_1.WIDGETS.ITEM_PROPERTIES_WIDGET, 
        // 352 = 16 - margin left, 336 - catalog widget's width
        // 104 = 72 margin top, 32 - margin bottom
        defaultPosition: {
            x: 352,
            y: windowHeight - widgetHeight - 104,
        } },
        react_1.default.createElement("div", { className: ItemPropertiesWidget_scss_1.default['widget'] },
            react_1.default.createElement(UI_1.Scrollable, { scrollbar: true }, item ? (react_1.default.createElement("div", { className: ItemPropertiesWidget_scss_1.default['container'] },
                react_1.default.createElement("div", { className: ItemPropertiesWidget_scss_1.default['item'] },
                    react_1.default.createElement("div", { className: ItemPropertiesWidget_scss_1.default['item-img'] },
                        react_1.default.createElement(UI_1.Image, { src: (0, utils_1.formatAssetsURL)(item.image.url) })),
                    react_1.default.createElement("div", null, `#${item.item_number}`)),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: ItemPropertiesWidget_scss_1.default['subtitle'] }, t('item.description')),
                    react_1.default.createElement("div", null, item.description)),
                ((_a = item.color) === null || _a === void 0 ? void 0 : _a.name) ? (react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: ItemPropertiesWidget_scss_1.default['subtitle'] }, t('item.color')),
                    react_1.default.createElement("div", null, item.color.name))) : null,
                react_1.default.createElement(ItemSizeEditor_1.default, { properties: item.itemProperties }),
                react_1.default.createElement(ItemPropertiesList_1.default, { itemProperties: item.itemProperties }),
                includedFasteners.map((includedFastener) => (react_1.default.createElement("div", { key: includedFastener.mountTo },
                    react_1.default.createElement("div", { className: ItemPropertiesWidget_scss_1.default['subtitle'] }, `Included Fasteners
                      ${includedFastener.mountTo ? ` (Mount to ${includedFastener.mountTo})` : ''}
                    `),
                    react_1.default.createElement(ItemImagePropertiesList_1.default, { properties: includedFastener.fasteners })))))) : (react_1.default.createElement("div", null, "Loading..."))))));
}
exports.default = ItemPropertiesWidget;
